export default __webpack_public_path__ + "/dist/images/findconnect-icon.1a20bb34cf656d62efcc900600119896.svg";